import { FileCheck2, FileText, ReceiptIndianRupee, Truck } from "lucide-react";

export const DOC_CONFIG = {
  quotations: {
    module: "quotations", title: "Quotations", singular: "Quotation", icon: FileText,
    subtitle: "Price offers you have sent to customers.",
    party: "customer", hasValidUntil: true, convertTo: "Proforma Invoice",
    statuses: ["Draft", "Sent", "Accepted", "Rejected", "Expired", "Converted to Proforma Invoice"],
  },
  proformas: {
    module: "proformas", title: "Proforma Invoices", singular: "Proforma Invoice", icon: FileCheck2,
    subtitle: "Advance payment documents raised before dispatch.",
    party: "customer", hasDueDate: true, hasPayments: true, convertTo: "Invoice",
    statuses: ["Draft", "Sent", "Payment Pending", "Partially Paid", "Paid", "Converted to Invoice", "Cancelled"],
  },
  invoices: {
    module: "invoices", title: "Invoices", singular: "Invoice", icon: ReceiptIndianRupee,
    subtitle: "Tax invoices raised against confirmed orders.",
    party: "customer", hasDueDate: true, hasPayments: true,
    statuses: ["Draft", "Sent", "Unpaid", "Partially Paid", "Paid", "Overdue", "Cancelled"],
  },
  "purchase-orders": {
    module: "purchase_orders", title: "Purchase Orders", singular: "Purchase Order", icon: Truck,
    subtitle: "Orders raised on your suppliers.",
    party: "supplier", hasExpectedDelivery: true, hasApproval: true,
    statuses: ["Draft", "Sent", "Approved", "Partially Received", "Fully Received", "Cancelled"],
  },
};

export const PURPOSES = ["Customer Order", "Stock Replenishment", "Amazon Order", "Other Purpose"];
export const PAYMENT_MODES = ["NEFT", "RTGS", "UPI", "Cheque", "Cash", "Credit Card", "Other"];
